export const GENDER_ARRAY = ['M', 'F', 'U'];

export const RESPONDENT_TYPE_ARRAY = ['INTERNAL', 'EXTERNAL'];

export const PUBLIC_GRAPHQL_OPERATIONS = {
  refreshToken: 'refreshToken',
  generateToken: 'generateToken',
};

export const buildAPIUrl = () => {
  if (window.GR8PI_API_ENDPOINT) {
    return `https://${window.GR8PI_API_ENDPOINT}/api/v1/questionnaire-scheduling`;
  }
  return 'https://api.gr8pi.org/api/v1/questionnaire-scheduling';
};

export const GR8PI_CREDENTIALS_STORE_KEY = 'gr8pi-credentials';

export const OWNEPLOYEEMAP = [
  {
    id: 'INTERNAL',
    name: 'attrs.candidateType.INTERNAL',
  },
  {
    id: 'EXTERNAL',
    name: 'attrs.candidateType.EXTERNAL',
  },
];

export const GR8PI_LOCALE_STORE_KEY = 'GR8PI_LOCALE_STORE_KEY';
